import { Location } from 'react-router-dom';

import {
  Block,
  CashReceiptUsage,
  Option,
  OrderLineWithId,
  OrderSheetParameter,
  SubOption,
  현금영수증_발행용도,
} from '@/apis';

import { safeLocalStorage } from './generateStorage';

export const updateTermsForm = (value: boolean) => {
  return {
    terms_comfirm: value,
    privacy_confirm: value,
    order_confirm: value,
    years_confirm: value,
    non_members_confirm: value,
  };
};

export const validateCashReceipt = (
  cashReceiptUsage: boolean | null,
  cashReceiptTypeSelected: string,
  cashReceiptNumber: string | null,
) => {
  // 가상 계좌 결제가 아니거나 현금영수증 미발행일 경우 true
  if (cashReceiptUsage === CashReceiptUsage.미발행) return true;

  if (cashReceiptUsage) {
    if (cashReceiptTypeSelected === 'personal_phone') {
      const format = /^01[0-9]{8,9}$/;
      if (!format.test(cashReceiptNumber as string)) return false;
    } else {
      const format = /^[0-9]{13,19}$/;
      if (!format.test(cashReceiptNumber as string)) return false;
    }
  } else {
    const format = /^[0-9]{10,19}$/;
    if (!format.test(cashReceiptNumber as string)) return false;
  }

  return true;
};

export const findOptionById = (options: Option[] | SubOption[], id: number) => {
  return options.find((option) => option.id === id);
};

export const generateCampaignName = (
  orderlines: OrderLineWithId[],
  block: Block,
  MAX_LENGTH: number = 64,
): string => {
  const [firstOrderLine, ...otherOrderLines] = orderlines;
  const { main_option_id: mainOptionId, sub_option_id: subOptionId, quantity } = firstOrderLine;

  const option = findOptionById(block?.campaign.options as Option[], mainOptionId as number);
  const subOption = findOptionById(block?.campaign.options as SubOption[], subOptionId as number);

  let campaignName = block?.campaign.name as string;
  if (option) campaignName += ` ${option.name}`;
  if (subOption) campaignName += ` ${subOption.name}`;

  const mainQuantity = ` ${quantity}개`;
  const remainingQuantity = otherOrderLines.length > 0 ? ` 외 ${otherOrderLines.length}개` : '';

  if (`${campaignName}${mainQuantity}${remainingQuantity}`.length >= MAX_LENGTH) {
    campaignName =
      campaignName.substring(0, MAX_LENGTH - (mainQuantity.length + remainingQuantity.length) - 3) +
      '...';
  }

  campaignName += mainQuantity;
  if (otherOrderLines.length > 0) campaignName += remainingQuantity;

  return campaignName;
};

export const getLocationState = (location: Location): OrderSheetParameter | null => {
  return location.state as OrderSheetParameter | null;
};

export const getLocalStorageOrderSheet = (loggedIn: boolean) => {
  return loggedIn
    ? (JSON.parse(safeLocalStorage.get('checkoutInfo') || '{}') as OrderSheetParameter)
    : null;
};

export const mapEToCashReceiptUsage = (e: string): 현금영수증_발행용도 => {
  switch (e) {
    case 'null':
      return CashReceiptUsage.미발행;
    case 'true':
      return CashReceiptUsage.소득공제용;
    case 'false':
      return CashReceiptUsage.지출증빙용;
    default:
      return CashReceiptUsage.미발행;
  }
};

export const mapCashReceiptUsageToE = (usage: 현금영수증_발행용도): string => {
  switch (usage) {
    case CashReceiptUsage.미발행:
      return 'null';
    case CashReceiptUsage.소득공제용:
      return 'true';
    case CashReceiptUsage.지출증빙용:
      return 'false';
    default:
      return 'null';
  }
};
